module.exports = __webpack_public_path__ + "static/operationBlockFunnel-1d0195889238c5f0397e57d20ba99ea9.gif";